module.exports = __webpack_public_path__ + "static/img/bg_0.65aaebd4.jpg";